export default __webpack_public_path__ + "static/media/printNew.e9f5ac8d.svg";